import { NAMED_CACHE_NAME } from "@/shared/utils/sw/sw.constants";
import { selectorNamedCacheKeysAvailable } from "@/shared/store/sw/selectorNamedCacheKeysAvailable";

export const selectorOfflineHistoryReadIds = (state) => {
  return selectorNamedCacheKeysAvailable(state)[NAMED_CACHE_NAME.OFFLINE_HISTORY_READ];
};